"use client"

import { useEffect, useState, type ReactNode } from "react"

export default function DraftModeOverlay() {
    const [overlay, setOverlay] = useState<ReactNode>(null)

    useEffect(() => {
        ;(async () => {
            const [
                { VisualEditing },
                { DisableDraftMode },
                { default: PreviewRefreshButton }
            ] = await Promise.all([
                import("next-sanity/visual-editing"),
                import("@/sanity/components/DisableDraftMode"),
                import("@/app/(site)/_components/Atoms/PreviewRefreshButton")
            ])

            setOverlay(
                <>
                    <PreviewRefreshButton />
                    <VisualEditing />
                    <DisableDraftMode />
                </>
            )
        })()
    }, [])

    return overlay
}
